import styled from 'styled-components';

import { colors } from '../../theme/theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;

  color: ${colors.placeholder};

  text-align: ${p => p.align};

  label {
    color: ${colors.primary};
    font-size: 0.75rem;
  }
`;

export { Container };
